import { Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import { Appbar } from "./AppBar";
import { Footer } from "./Footer";

const AttendanceFormLayout = ({children}: {children: React.ReactNode}) => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Appbar />
      <main className={styles.content}>
        <div className={styles.toolbar} />
        <div className={styles.children}>{children}</div>
        <Footer />
      </main>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    minHeight: "100vh",
    position: "relative",
  },
  children: {
    marginBottom: theme.spacing(10),
  },
  toolbar: theme.mixins.toolbar,
}));

export { AttendanceFormLayout };
